import { Axios, AxiosPrivate } from '../../utils';
import { LoginRequest, AccessCodeRequest, UserInfo, SuccessfulResponse, RedeemedCollection, Token } from '../../types';
import TokenService from '../../services/TokenService';

class AuthAPI {
  private static instance: AuthAPI;

  public static getInstance(): AuthAPI {
    if (!AuthAPI.instance) {
      AuthAPI.instance = new AuthAPI();
    }

    return AuthAPI.instance;
  }

  login = async (loginInfo: LoginRequest) => {
    const response = await Axios.post<Token>('/v1/auth/login', JSON.stringify(loginInfo));
    TokenService.setAuthorizationToken(response.data.accessToken);
    const firstTime = localStorage.getItem('firstTime');
    if (!firstTime) {
      // first time loaded!
      localStorage.setItem('firstTime', 'true');
    }
    return response;
  };

  me = () => {
    return AxiosPrivate.get<UserInfo>('/v1/auth/me');
  };

  refresh = async () => {
    try {
      const response = await Axios.post<Token>('/v1/auth/refresh');
      TokenService.setAuthorizationToken(response.data.accessToken);
      return response.data.accessToken;
    } catch (error) {
      TokenService.clearAuthorizationToken();
      throw error;
    }
  };

  redeemCode = async (accessCodeRequest: AccessCodeRequest) => {
    return await AxiosPrivate.post<RedeemedCollection>('/v1/auth/redeem-code', JSON.stringify(accessCodeRequest));
  };

  logout = async () => {
    const response = await AxiosPrivate.post<SuccessfulResponse>('/v1/auth/logout');
    TokenService.clearAuthorizationToken();
    return response;
  };
}

export const authAPI = AuthAPI.getInstance();
